// removed by extract-text-webpack-plugin
module.exports = {"healthChecksContainer":"health-checks_healthChecksContainer--1X-DFDV8","healthCheck":"health-checks_healthCheck--28yw9UBG","body":"health-checks_body--1kR7S5vT","header":"health-checks_header--GgwaUlcI","name":"health-checks_name--GjCJ-MYN","price":"health-checks_price--2uMXPh5f","description":"health-checks_description--1aeEiRRA","cards":"health-checks_cards--2zG_oOf8"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-right-section/src/styles/health-checks.scss
// module id = 2337
// module chunks = 0